import { render, staticRenderFns } from "./City.vue?vue&type=template&id=6d041355"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d041355')) {
      api.createRecord('6d041355', component.options)
    } else {
      api.reload('6d041355', component.options)
    }
    module.hot.accept("./City.vue?vue&type=template&id=6d041355", function () {
      api.rerender('6d041355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/City.vue"
export default component.exports